export default "__VITE_ASSET__DOZA9lUr__"